export const LIST_EXAM_CATEGORY = 'LIST_EXAM_CATEGORY';
export const CREATE_EXAM_CATEGORY = 'CREATE_EXAM_CATEGORY';
export const SHOW_EXAM_CATEGORY = 'SHOW_EXAM_CATEGORY';
export const UPDATE_EXAM_CATEGORY = 'UPDATE_EXAM_CATEGORY';
export const DELETE_EXAM_CATEGORY = 'DELETE_EXAM_CATEGORY';
export const ADD_DELETE = 'ADD_DELETE';
export const CHECK_ALL = 'CHECK_ALL';
export const DATA_REMOVE_EXAM_CATEGORY = 'DATA_REMOVE_EXAM_CATEGORY';